import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-freeze',
  templateUrl: './freeze.component.html',
  styleUrls: ['./freeze.component.scss'],
})
export class FreezeComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
